<script lang="ts">
  export type QuickAction = { id: string; label: string; icon?: string };

  let {
    actions,
    onAction,
  }: {
    actions: QuickAction[];
    onAction: (id: string) => void;
  } = $props();
</script>

<div class="actions">
  {#key actions.length}
  {#each actions as a (a.id)}
    <button type="button" class="glass-btn" onclick={() => onAction(a.id)}>
      {#if a.icon}<span class="ico">{a.icon}</span>{/if}
      {a.label}
    </button>
  {/each}
  {/key}
</div>

<style>
  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.65rem 0.75rem;
    background: rgba(255,255,255,0.45);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-xl);
    box-shadow: var(--glass-shadow);
  }

  .glass-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 1rem;
    border-radius: 999px;
    border: 1px solid var(--glass-border);
    background: var(--glass-bg-card);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: var(--text-primary);
    font: inherit;
    font-size: 0.8rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: var(--shadow-sm);
    letter-spacing: -0.01em;
  }

  .glass-btn:hover {
    background: var(--brand-surface);
    border-color: var(--brand-strong);
    color: var(--brand-deep);
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 6px 20px rgba(124,58,237,0.2), 0 0 0 2px rgba(124,58,237,0.1);
  }

  .glass-btn:active {
    transform: translateY(0) scale(0.97);
  }

  .ico { font-size: 1rem; }
</style>
